export default __webpack_public_path__ + "img/cNDRnIyS.1c70f183.svg";